angular.module('workflow')
    .constant('WorkflowAccessGroupConst', {
        eventUpdate: 'workflow-access-group.updated'
    })
    .factory('WorkflowAccessGroup', function ($resource) {
        return $resource('/crm/api/workflow-access-group/:id', { id: '@id' }, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            autocomplete: { method: 'GET', isArray: true, url: '/crm/api/workflow-access-group/autocomplete' },
        })
    })
    .service('WorkflowAccessGroupService', function ($rootScope, modals, WorkflowAccessGroup, WorkflowAccessGroupConst) {
        this.add = params => {
            let entity = {
                id: null,
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            return modals.open('app/workflow/access-group/edit-modal.html', 'WorkflowAccessGroupDialogController', angular.copy(entity), {}, "$ctrl")
        }
        this.list = () => {
            return modals.open('app/workflow/access-group/list-modal.html', 'WorkflowAccessGroupListController', {}, {size: 'md'}, "$ctrl")
        }
        this.remove = function (item) {
            return modals.confirmDelete(item.name, () => WorkflowAccessGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(WorkflowAccessGroupConst.eventUpdate)))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('workflowAccessGroupList', {
            parent: 'app',
            url: '/workflow-access-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'workflowAccessGroupList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (WorkflowAccessGroup, $q, $stateParams) => WorkflowAccessGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
